<template>
  <div class="tree-box">
    <div class="main panel-loading" v-loading="treeLoading" element-loading-text="加载中…">
      <div class="head">
        <div class="title">区域管理</div>
        <!-- <div class="search">
          <div class="container">
            <el-input placeholder="区域名称查询" v-model.trim="filterText" clearable @clear="searchAreaByname()">
            </el-input>
            <img src="@/assets/image/common/search-hui.png" @click="searchAreaByname()" />
          </div>
        </div> -->

      </div>
      <div class="tree-container">
        <el-scrollbar>
          <!-- :default-expanded-keys="defaultExpandIds"  :filter-node-method="filterNode"-->

          <el-tree ref="tree" :load="lazyLoad" lazy :data="treeData" empty-text="" :props="defaultProps" node-key="id"
            @node-click="handleNodeClick" :expand-on-click-node="false" :current-node-key="currentNode"
            @node-expand="handleNodeExpand" @node-collapse="handleNodeCollapse"
            :default-expanded-keys="defaultExpandIds" :accordion="true" :draggable="draggable" :allow-drop="allowDrop"
            @node-drop="handleDrop">
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <div class="tree-label" v-if="!data.showInput">
                <span class="label-container">
                  <!-- <img src="@/assets/image/common/select.png" v-if="showAlter && radioNode === data.id"
                    @click.stop="handleSelect(data)" />
                  <img src="@/assets/image/common/no-select.png" v-if="showAlter && radioNode !== data.id"
                    @click.stop="handleSelect(data)" /> -->
                  <div class="select-yuan" v-if="showAlter" :class="{ 'select-yuan-act': radioNode === data.id }"
                    @click.stop="handleSelect(data)"></div>

                  <template v-if="data.areaName.length > 10">
                    <el-tooltip class="item" effect="dark" :content="data.areaName" placement="top">
                      <span class="area-name" :nodeid="data.id">{{
      data.areaName
    }}</span>
                    </el-tooltip>
                  </template>
                  <template v-else>
                    <span class="area-name" :nodeid="data.id">{{
      data.areaName
    }}</span>
                  </template>
                </span>
                <div class="handle">
                  <template v-if="!showAlter">
                    <img class="add" src="@/assets/image/common/circle-add.png" v-if="data.areaLevel < 3"
                      @click.stop="handleAdd(node, data)" />
                    <img src="@/assets/image/common/icon-quxiao.png" v-if="data.id != rootNode"
                      @click.stop="handleDel(data, node)" />
                    <img src="@/assets/image/common/icon-bj.png" v-if="data.id != rootNode"
                      @click.stop="handleEdit(node, data)" />
                  </template>



                </div>
              </div>
              <div class="tree-label" v-else>
                <el-input ref="areaInput" v-model="nodeLabel" placeholder="请输入区域名称" @click.native.stop
                  @focus.native.stop maxlength="20"></el-input>
                <div class="handle save">
                  <img src="@/assets/image/common/circle-cuo.png" @click.stop="closeTreeInput" />
                  <img src="@/assets/image/common/circle-dui.png" @click.stop="saveAreaTree(node, data)" />
                </div>
              </div>
            </div>
          </el-tree></el-scrollbar>
      </div>
      <div class="tree-no-data" v-if="treeData.length === 0 || showEmpty">
        <img src="@/assets/image/common/no-area.png" />
        {{ showEmpty ? "暂未添加区域信息" : "暂未添加区域信息" }}
      </div>
    </div>
    <div class="btn-box" v-show="showAlter">
      <!-- <el-button type="primary" @click="changeDeviceArea">确定更改</el-button>
      <el-button @click="closeAlter">取消</el-button> -->
      <div class="btn-item" @click="changeDeviceArea">确定</div>
      <div class="btn-item btn-item2" @click="closeAlter">取消</div>
    </div>
    <div class="btn-box" v-show="draggable">
      <el-button type="primary" @click="draggableClick(false)">关闭排序</el-button>
    </div>
    <!-- 树形删除确认框 -->
    <el-dialog :title="delItem.areaName" :visible.sync="dialogVisible" custom-class="dialog-treedel" :show-close="false"
      :modal-append-to-body="false">
      <span>确定删除该区域信息吗？</span>
      <div class="red-txt">(删除后，产品将移动到全区域)</div>
      <div slot="footer" class="flex dialog-footer">
        <div class="treedia-btn treedia-cancle" @click="handleDeteleCancle">
          取 消
        </div>
        <div class="treedia-btn treedia-submit" @click="handleDeteleSubmit">
          确 定
        </div>
      </div>
    </el-dialog>
    <Msg ref="myMsg"></Msg>
  </div>
</template>
<script>
import Msg from "@/components/msg.vue"; //信息提示组件
import { baseUrl } from "@/api/request";
export default {
  props: ["showAlter", "multipleSelection"],
  components: { Msg },
  data() {
    return {
      specificAreaName: "",
      sortBy: "",
      filterText: "",
      paramsfilterText: "",
      nodeLabel: "",
      treeData: [],
      nowShowInputNodeId: [],
      defaultProps: {
        children: "children",
        label: "areaName",
        isLeaf: "hasSub",
      },
      showEmpty: false,
      treeLoading: false,
      rootNode: "0",
      currentNode: null,
      currentName: null,
      radioNode: null,

      // 记录展开状态
      defaultExpandIds: ["0"],
      draggable: false,
      delItem: {}, // 删除的数据
      dialogVisible: false,
    };
  },
  watch: {
    currentNode() {
      this.setNodeColor();
    },
    showAlter() {
      this.radioNode = null;
    },
    treeData: {
      handler(val) {
        console.log(val);
        if (!val.length) {
          return
        }
        if (val[0].children && val[0].children.length) {
          this.showEmpty =
            document.getElementsByClassName("el-tree__empty-block").length === 1
              ? true
              : false;
        } else {
          this.showEmpty = true
        }
      },
      deep: true,
      immediate: true,
    },
    // treeData(val) {
    //   console.log(val);
    //   if (val[0].children && val[0].children.length) {
    //     this.showEmpty =
    //       document.getElementsByClassName("el-tree__empty-block").length === 1
    //         ? true
    //         : false;
    //   } else {
    //     this.showEmpty = true
    //   }
    // },
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    //   this.$nextTick(() => {
    //     if (this.treeData[0].children && this.treeData[0].children.length) {
    //       this.showEmpty =
    //         document.getElementsByClassName("el-tree__empty-block").length === 1
    //           ? true
    //           : false;
    //     } else {
    //       if (val == "") {
    //         this.showEmpty = true;
    //       }
    //     }
    //   });
    // },
  },
  created() {
    // this.schoolId = localStorage.getItem('schoolId')
    // this.schoolName = localStorage.getItem('organName')
    // this.specificAreaName = baseUrl.split("/")[1];
    // this.getAreaTree();
  },
  mounted() { },
  methods: {
    // 树节点查询
    filterNode(value, data) {
      if (!value) return true;
      return data.areaName.indexOf(value) !== -1;
    },

    // 确定更改区域
    async changeDeviceArea() {
      if (!this.radioNode) {
        // this.$modal.msgError("请选择更改区域");
        this.$refs.myMsg.msgShow("请选择更改区域", 1.5);
        return;
      }
      if (this.multipleSelection.length === 0) {
        // this.$modal.msgError("请选择设备");
        this.$refs.myMsg.msgShow("请选择设备", 1.5);
        return;
      }
      // let params = {
      //   bos: this.multipleSelection,
      // }
      // console.log(params)
      // this.$modal.loading("正在加载中...");
      let params = []
      this.multipleSelection.forEach((item) => {
        params.push({
          deviceId: item.deviceId,
          deviceType: item.deviceType,
          subDeviceNum: item.subDeviceNum,
          subDeviceType: item.subDeviceType
        })
      })
      this.$http.postAction(
        `${this.$api.magicCubebindArea}/${this.radioNode}`,
        params
      ).then((res) => {
        if (res.code == 200) {
          // 重新获取当前选中的区域下的设备列表

          this.handleNodeClick(
            {
              id: this.currentNode,
              areaName: this.currentName,
            },
            true
          );
          this.closeAlter();
          // this.$modal.msgSuccess("更改区域成功");
          this.$refs.myMsg.msgShow("更改区域成功", 1.5);
        } else {
          // this.$modal.msgError("更改区域失败");
          this.$refs.myMsg.msgShow(res.msg, 1.5);
        }
        this.$emit("loadData")
      });

    },
    // 关闭更改区域
    closeAlter() {
      this.$emit("updateShow", false);
    },
    // 获取tree-区域列表
    async getAreaTree(node, resolve) {
      this.treeData = [
        {
          id: "0",
          areaLevel: "1",
          areaSort: "1",
          areaName: "全区域",
          isLeaf: false,
        },
      ];
      resolve(this.treeData);
      this.$emit("updateTreeData", []);

      this.handleNodeClick(this.treeData[0]);
      this.$nextTick(() => {
        this.setNodeColor();
      });
    },
    lazyLoad(node, resolve) {
      setTimeout(() => {
        if (node.level == 0) {
          this.getAreaTree(node, resolve);
        } else {
          this.getDistrict(node, resolve);
        }
      }, 100);
    },
    getProvence(node, resolve) {
      this.$http
        .getAction(this.$api.getSubAreaList + "?areaId=" + node.data.id)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            resolve(res.data.data);
            // 刷新树形组件
          }
        });
    },
    getDistrict(node, resolve) {
      // console.log(node);
      let params = "?areaId=" + node.data.id;
      if (this.sortBy) {
        if (this.sortBy == 1) {
          params += "&sortBy=0";
        } else if (this.sortBy == 2) {
          params += "&sortBy=1";
        }
      }
      //  && node.data.id == 0
      let bool = node.label.indexOf(this.paramsfilterText) != -1;
      let boolParent = false;
      if (node.parent.label) {
        boolParent = node.parent.label.indexOf(this.paramsfilterText) != -1;
      }
      // 判断当前层级或者父级是否已经包含搜索项
      if (this.paramsfilterText && !(bool || boolParent)) {
        params += "&areaName=" + this.paramsfilterText;
      }
      this.$http.postAction(this.$api.getSubAreaList + params).then((res) => {
        // console.log(res);

        if (res.code == 200) {

          if (!res.data || !res.data.length) {
            if (node.data.id == 0) {
              this.showEmpty = true;
            }
            resolve([]);

            return;
          }
          if (node.data.id == 0) {
            this.showEmpty = false;
          }
          // this.setTreeData(node.data.id, res.data.data);
          res.data.forEach((item) => {
            item.hasSub = !item.hasSub
            // if (item.areaLevel < 3) {
            //   item.hasSub = false;
            // } else {
            //   item.hasSub = true;
            // }

          });
          resolve(res.data);
        }
      });
    },
    // 给treeData赋值
    setTreeData(id, children) {
      function recursion(treeData) {
        for (let node of treeData) {
          if (node.id === id) {
            node.children = children;
            return;
          }
          if (node.children && node.children.length > 0) {
            recursion(node.children);
          }
        }
      }
      recursion(this.treeData);
      this.$forceUpdate();
    },
    // 设置选中节点的背景色
    setNodeColor() {
      let list = document.getElementsByClassName("area-name");
      Array.from(list).forEach((item) => {
        if (item.getAttribute("nodeid") == this.currentNode) {
          item.parentElement.parentElement.parentElement.parentElement.classList.add(
            "tree-active-node"
          );
        } else {
          item.parentElement.parentElement.parentElement.parentElement.classList.remove(
            "tree-active-node"
          );
        }
      });
    },
    // 查找树结构指定节点
    findNodeInTreeByCode(data, id) {
      for (let node of data) {
        if (node.id === id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const foundNode = this.findNodeInTreeByCode(node.children, id);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    },

    // 点击节点
    handleNodeClick(data, isFlag) {
      if (this.draggable) {
        return;
      }
      // 更改区域时禁止点击
      if (!this.showAlter || isFlag === true) {
        this.currentNode = data.id;
        this.currentName = data.areaName;
        this.$emit("changeAreaId", { id: data.id, name: data.areaName });
      }
    },

    // 展开节点时触发的函数
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultExpandIds.some((item) => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandIds.push(data.id);
      }
    },

    // 树节点关闭
    handleNodeCollapse(data) {
      // // 删除当前关闭的节点
      this.removeChildrenIds(data); // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1);
        }
      });
    },

    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this;
      let nowNode = this.$refs.tree.getNode(data.id);
      let childNodes = nowNode.childNodes.map(function (item) {
        return item.data;
      });
      // if (data.children) {
      //   data.children.forEach(function (item) {
      //     const index = ts.defaultExpandIds.indexOf(item.id);
      //     if (index > 0) {
      //       ts.defaultExpandIds.splice(index, 1);
      //     }
      //     ts.removeChildrenIds(item);
      //   });
      // }
      if (childNodes) {
        childNodes.forEach(function (item) {
          const index = ts.defaultExpandIds.indexOf(item.id);
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1);
          }
          ts.removeChildrenIds(item);
        });
      }
    },
    // 删除确认
    handleDeteleSubmit() {
      // 请求删除接口
      this.$http
        .postAction(this.$api.sysspacedelete + '?areaId=' + this.delItem.id)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            // this.$message('区域删除成功!', 'success')
            this.$refs.myMsg.msgShow("区域删除成功", 1.5);
          } else {
            // this.$message(res.msg, 'error')
            this.$refs.myMsg.msgShow(res.msg, 1.5);

          }
          let nowNode = this.$refs.tree.getNode(this.delItem.id);
          this.updatetreeByBaBa(nowNode, this.delItem);
          this.$emit("loadData")
          this.$emit("treeDataUpdate")
        })
        .finally(() => {
          this.dialogVisible = false

          setTimeout(() => {
            this.delItem = {}
          }, 500)
        })
    },
    // 删除取消
    handleDeteleCancle() {
      this.dialogVisible = false
      setTimeout(() => {
        this.delItem = {}
      }, 500)
    },

    // 选择更改区域
    handleSelect(data) {
      this.radioNode = data.id;
      // console.log(this.radioNode)
    },

    // 更新tree显示的input
    updateTreeInput(nowId, parentId, isBoolean) {
      // let parent = this.findNodeInTreeByCode(this.treeData, parentId);
      // if (nowId === -1 && isBoolean === false) {
      //   // 新增-输入框-关闭
      //   // console.log(123123123)
      //   let children = [];
      //   parent.children.forEach((item, index) => {
      //     if (index < parent.children.length - 1) {
      //       children.push(item);
      //     }
      //   });
      //   this.$set(parent, "children", children);
      // } else {
      //   // 编辑-输入框
      //   let i = parent.children.findIndex((item) => item.id === nowId);
      //   console.log(i);
      //   this.$set(parent.children, i, {
      //     ...parent.children[i],
      //     showInput: isBoolean,
      //   });
      //   console.log(parent);
      //   this.$refs.tree.updateKeyChildren(parent.id, parent.children);
      // }

      // // 懒加载后修改
      let parent = this.$refs.tree.getNode(parentId);
      if (nowId === -1 && isBoolean === false) {
        // 新增-输入框-关闭
        let childNodes = [];
        let childs = parent.childNodes.map(function (item) {
          return item.data;
        });
        childs.forEach((item, index) => {
          if (item.id != -1) {
            childNodes.push(item);
          }
        });
        this.$refs.tree.updateKeyChildren(parent.data.id, childNodes);
      } else {
        // 编辑-输入框
        let i = parent.childNodes.findIndex((item) => item.data.id === nowId);
        let nowNode = this.$refs.tree.getNode(nowId);
        nowNode.data.showInput = isBoolean;
        let childNodes = parent.childNodes.map(function (item) {
          return item.data;
        });
        this.$refs.tree.updateKeyChildren(parent.data.id, childNodes);
      }
    },

    // 新增区域按钮
    handleAdd(node, data) {
      // console.log(data);
      // 先关闭上一个输入框
      if (this.nowShowInputNodeId.length > 0) {
        this.$refs.tree.remove(this.nowShowInputNodeId[0]);
        this.updateTreeInput(
          this.nowShowInputNodeId[0],
          this.nowShowInputNodeId[1],
          false
        );
      }
      // 保存当前的输入框节点ID
      this.nowShowInputNodeId = [-1, data.id];
      this.nodeLabel = "";
      this.$nextTick(() => {
        // 先判断是否获取了子节点
        if (!node.childNodes.length) {
          //未获取子节点
          node.expanded = true;
          this.$http
            .postAction(this.$api.getSubAreaList + "?areaId=" + node.data.id)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                let childNodes = [];
                if (res.data) {
                  childNodes = res.data;
                }
                let obj = {
                  id: -1,
                  areaName: "",
                  showInput: true,
                };
                childNodes.unshift(obj);
                // 保存当前的输入框节点ID
                this.nowShowInputNodeId = [-1, data.id];
                childNodes.forEach((item) => {
                  this.$refs.tree.append(item, node.data.id);
                });
                this.getInputFocus();
              }
            });
        } else {
          // 获取过了子节点
          node.expanded = true;
          let childNodes = node.childNodes.map(function (item) {
            return item.data;
          });
          let obj = {
            id: -1,
            areaName: "",
            showInput: true,
          };
          childNodes.unshift(obj);
          this.nowShowInputNodeId = [-1, data.id];
          // this.$refs.tree.updateKeyChildren(node.data.id, childNodes);
          this.$refs.tree.insertBefore(obj, childNodes[1].id);
          this.getInputFocus();
        }
        // return;
      });

      return;
      node.expanded = true;
      this.handleNodeExpand(data);
      // 先关闭上一个输入框
      if (this.nowShowInputNodeId.length > 0) {
        this.updateTreeInput(
          this.nowShowInputNodeId[0],
          this.nowShowInputNodeId[1],
          false
        );
      }
      // 保存当前的输入框节点ID
      this.nowShowInputNodeId = [-1, data.id];
      this.nodeLabel = "";
      // let nodeData = this.findNodeInTreeByCode(this.treeData, data.id);
      // let obj = {
      //   id: -1,
      //   areaName: "",
      //   showInput: true,
      // };
      // if (nodeData.children && nodeData.children.length > 0) {
      //   let list = [...nodeData.children, obj];
      //   this.$set(nodeData, "children", list);
      // } else {
      //   this.$set(nodeData, "children", [obj]);
      // }
      // 懒加载后修改
      let nodeData = this.$refs.tree.getNode(data.id);
      let obj = {
        id: -1,
        areaName: "",
        showInput: true,
      };
      let childNodes;
      if (nodeData.childNodes && nodeData.childNodes.length > 0) {
        childNodes = nodeData.childNodes.map(function (item) {
          return item.data;
        });
        childNodes.push(obj);
      } else {
        childNodes = [obj];
      }
      this.$refs.tree.updateKeyChildren(nodeData.data.id, childNodes);
      this.getInputFocus();
    },

    // 手动获取焦点
    getInputFocus() {
      this.$nextTick(() => {
        if (this.$refs.areaInput) {
          setTimeout(() => {
            this.$refs.areaInput.focus();
          }, 0);
        }
      });
    },
    //通过父节点更新子节点
    updatetreeByBaBa(node, data) {
      this.treeLoading = true;
      let params = "?areaId=0";
      if (this.sortBy) {
        if (this.sortBy == 1) {
          params += "&sortBy=0";
        } else if (this.sortBy == 2) {
          params += "&sortBy=1";
        }
      }
      if (this.paramsfilterText) {
        params += "&areaName=" + this.paramsfilterText;
      }
      this.$http
        .postAction(this.$api.getSubAreaList + params)
        .then((res) => {
          this.treeLoading = false;
          if (res.code == 200) {
            let childNodes = [];
            if (res.data) {
              res.data.forEach((item) => {
                item.hasSub = !item.hasSub
                // if (item.areaLevel < 3) {
                //   item.hasSub = false;
                // } else {
                //   item.hasSub = true;
                // }

              });
              childNodes = res.data;
              this.showEmpty = false;
            }
            this.$refs.tree.updateKeyChildren(0, childNodes);
            this.nowShowInputNodeId = [];
            if (!res.data || !res.data.length) {
              this.showEmpty = true;
            }
          }
        })
        .catch(() => {
          this.treeLoading = false;
          this.nowShowInputNodeId = [];
        });
    },
    // 编辑区域-按钮
    handleEdit(node, data) {
      // 先关闭上一个输入框
      if (this.nowShowInputNodeId.length > 0) {
        this.updateTreeInput(
          this.nowShowInputNodeId[0],
          this.nowShowInputNodeId[1],
          false
        );
      }
      // 保存当前的输入框节点ID
      this.nowShowInputNodeId = [data.id, node.parent.data.id];
      // 显示当前节点输入框
      this.nodeLabel = data.areaName;
      this.updateTreeInput(
        this.nowShowInputNodeId[0],
        this.nowShowInputNodeId[1],
        true
      );

      this.getInputFocus();
    },

    // 关闭输入框
    closeTreeInput() {
      this.updateTreeInput(
        this.nowShowInputNodeId[0],
        this.nowShowInputNodeId[1],
        false
      );
      this.nowShowInputNodeId = [];
    },

    // 删除区域
    handleDel(data, node) {
      // this.$confirm("您确认要删除该区域吗?", "删除区域", {
      //   confirmButtonText: "确认",
      //   cancelButtonText: "取消",
      //   customClass: "common-confirm",
      // })
      //   .then(async () => {
      //     // this.treeLoading = true;
      //     try {
      //       const { data: res } = await this.$http.postAction(
      //         this.$api.deleteAreaTree + "?areaId=" + data.id
      //       );
      //       if (res.code == 200) {
      //         this.$modal.msgSuccess("删除区域成功");
      //       } else {
      //         this.treeLoading = false;
      //         this.$modal.msgError("删除区域失败");
      //       }
      //       // this.getAreaTree();
      //       this.updatetreeByBaBa(node, data);
      //     } catch (error) {
      //       // this.treeLoading = false;
      //     }
      //   })
      //   .catch(() => { });
      // 二次确认删除
      this.dialogVisible = true
      // 赋值需要删除的数据
      this.delItem = data
    },

    // 新增一个区域
    async saveAreaTree(node, data) {
      if (data.id === -1) {
        // 新增
        if (!this.nodeLabel) {
          // this.$modal.msgError("请输入区域名称");
          this.$refs.myMsg.msgShow("请输入区域名称", 1.5);
          return;
        }
        let children = node.parent.data.children;
        let areaSort = null;
        for (let i = 0; i < children.length; i++) {
          if (children[i].id === -1 && i !== 0) {
            areaSort = Number(children[i - 1].areaSort) + 1 + "";
          }
        }
        let params = {
          // specificAreaName: this.specificAreaName,
          areaPid: node.parent.data.id, // 区域父id
          areaName: this.nodeLabel,
          areaLevel: Number(node.parent.data.areaLevel) + 1 + "",
          // areaType: "classroom",
          areaSort: areaSort || "1",
        };

        try {
          // this.treeLoading = true;
          this.$http.postAction(
            this.$api.sysspacesave,
            params
          ).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              // this.$modal.msgSuccess("新增区域成功");
              this.$refs.myMsg.msgShow("新增区域成功", 1.5);
              // this.closeTreeInput();
            } else {
              this.treeLoading = false;
              // this.$modal.msgError("新增区域失败");
              this.$refs.myMsg.msgShow("新增区域失败", 1.5);
            }
            this.updatetreeByBaBa(node, data);
            this.$emit("loadData")
            // this.getAreaTree();
            // 通过父节点更新子节点
          });

        } catch (error) {
          this.treeLoading = false;
        }
      } else {
        // 编辑
        let params = {
          // ...data,
          areaName: this.nodeLabel,
          id: data.id,
          // areaType: data.areaType,
          // areaSort: data.areaSort,
        };
        try {
          // this.treeLoading = true;
          const { data: res } = await this.$http.putAction(
            this.$api.sysspaceupdateBatch,
            [params]
          ).then((res) => {
            if (res.code == 200) {
              // this.closeTreeInput();
              // this.getAreaTree();
              // this.$modal.msgSuccess("编辑区域成功");
              this.$refs.myMsg.msgShow("编辑区域成功", 1.5);
            } else {
              this.treeLoading = false;
              // this.$modal.msgError("编辑区域失败");
              this.$refs.myMsg.msgShow("编辑区域失败", 1.5);
            }
            this.updatetreeByBaBa(node, data);
            this.$emit("loadData")
          });

        } catch (error) {
          this.treeLoading = false;
        }
      }
      this.$emit("treeDataUpdate")
    },
    // 区域排揎方式点击
    sortByClick(type) {
      if (this.sortBy == type) {
        this.sortBy = "";
        this.defaultExpandIds = [0];
        this.updatetreeByBaBa();
        return;
      }
      this.sortBy = type;
      this.defaultExpandIds = [0];
      this.updatetreeByBaBa();
    },
    // 搜索区域
    searchAreaByname() {
      this.defaultExpandIds = [0];
      this.paramsfilterText = this.filterText.trim();
      this.updatetreeByBaBa();
    },
    // 下载二维码
    downloadQR() {
      this.$confirm("是否要下载区域二维码?", "区域二维码", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "common-confirm",
      })
        .then(async () => {
          // this.$modal.loading("正在加载中...");

          let params = {
            areaName: this.filterText,
            // specificAreaName: this.specificAreaName,
            sortBy: this.sortBy,
          };
          this.$http
            .postAction(this.$api.generateQrCodeAndUploadArea, params)
            .then((res) => {
              if (res.data.code == 200 && res.data.data) {
                const link = document.createElement("a");
                link.href = res.data.data;
                link.click();
                this.$nextTick(() => {
                  this.$modal.closeLoading();
                });
              } else {
                this.$modal.msgError(res.data.msg);
                this.$nextTick(() => {
                  this.$modal.closeLoading();
                });
              }
            })
            .finally(() => { });
        })
        .catch(() => { });
    },
    // 区域排序
    draggableClick(bool) {
      this.draggable = bool;
      this.$emit("draggableChangeEvent", bool);
    },
    // 拖拽时判定目标节点能否被放置
    allowDrop(draggingNode, dropNode, type) {
      // console.log(draggingNode, dropNode, type);

      // 判断拖拽的树是否是同一级别
      if (draggingNode.level == dropNode.level) {
        if (draggingNode.data.areaPid === dropNode.data.areaPid) {
          return type == "prev" || type == "next";
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // 拖拽完成事件
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log(dropNode);
      this.treeLoading = true;
      let arr = dropNode.parent.childNodes;
      let paramsArr = [];
      arr.forEach((item, index) => {
        paramsArr.push({
          id: item.key,
          areaSort: index + 1,
        });
      });
      this.$http
        .postAction(this.$api.updateAreaSort, paramsArr)
        .then(({ data: res }) => {
          console.log(res);
          this.treeLoading = false;
          if (res.code == 200) {
            // this.$modal.msgSuccess("排序成功");
            this.$refs.myMsg.msgShow("排序成功", 1.5);
          } else {
            // this.$modal.msgError(res.msg);
            this.$refs.myMsg.msgShow(res.msg, 1.5);
          }
        })
        .catch((err) => {
          console.log(err);
          this.treeLoading = false;
          this.updatetreeByBaBa(dropNode.parent, dropNode.parent.data);
        });
    },
  },
};
</script>
<style lang="scss">
.screen-popper {
  padding-left: 0;
  padding-right: 0;
  padding-top: 7px;
  padding-bottom: 7px;

  .list_box {
    .li {
      height: 31px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #96a1af;
      line-height: 31px;
      cursor: pointer;
      text-align: center;

      &:hover {
        background: #edf3fe;
        color: #6f9bf7;
      }
    }

    .li_active {
      background: #edf3fe;
      color: #6f9bf7;
    }
  }
}
</style>
<style lang="scss" scoped>
.tree-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .main {
    width: 100%;
    flex: 1;
    min-height: 0;
    background: #ffffff;
    border-radius: 8px;
    // padding: 10px 0 10px 10px;
    position: relative;
    display: flex;
    flex-direction: column;

    .tree-container {
      margin-top: 10px;
      flex: 1;
      width: 100%;
      min-height: 0;
      padding-left: .3rem;

      ::v-deep .el-tree-node__expand-icon {
        font-size: 16px !important;
        // padding: 10px 15px;
        padding: 2px;
      }

      >.el-scrollbar {
        height: 100%;
        box-sizing: border-box;
        padding-right: 10px;
        // ::v-deep .el-scrollbar__bar {
        //   right: -6px !important;
        // }

        ::v-deep .el-scrollbar__thumb {
          background: #f4f4f4 !important;
        }
      }
    }

    .tree-no-data {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #96a1af;

      img {
        width: 230px;
        margin-bottom: 10px;
      }
    }
  }

  .btn-box {
    height: 70px;
    width: 100%;
    margin-top: 14px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-button {
      width: 100px !important;
      height: 42px !important;
      padding: 0 !important;
    }

    .btn-item {
      margin: 0 15px;
      cursor: pointer;
      width: 140px;
      height: 36px;
      background: #2DAEA9;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #FEFFFF;
      border: 1px solid #2DAEA9;
      box-sizing: border-box;
    }

    .btn-item2 {
      background: #FFFFFF;
      color: #2DAEA9;
    }
  }

  .head {
    display: flex;
    align-items: center;
    width: 100%;
    height: .8rem;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
    padding-left: .3rem;

    .title {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 16px;
      color: #3e4a70;
      margin-right: 13px;
    }

    .search {
      flex: 1;
      min-height: 0;
      display: flex;
      align-items: center;

      .container {
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        border-radius: 20px;
        border: 1px solid #f1f1f1;
        overflow: hidden;

        ::v-deep .el-input {
          height: 40px !important;
          border: none;

          .el-input__inner {
            height: 100% !important;
            border: none;
            padding-left: 26px;
          }
        }

        img {
          width: 15px;
          margin-right: 19px;
          cursor: pointer;
        }
      }
    }

    .icon_box {
      display: flex;
      align-items: center;
      margin-left: 7px;

      img {
        cursor: pointer;
        margin: 0px 7px;
      }
    }
  }

  .el-tree {
    ::v-deep .el-tree-node__content {
      background-color: transparent;
      height: 42px !important;

      &:hover {
        background-color: #f5f7fa !important;
      }

      // &:focus {
      //   background-color: transparent;
      // }
      // &:active {
      //   background-color: transparent;
      // }
      // &:visited {
      //   background-color: transparent;
      // }
    }

    // ::v-deep .el-tree-node {
    //   &:hover {
    //     background-color: transparent;
    //   }
    //   &:focus {
    //     background-color: transparent;
    //   }
    //   &:active {
    //     background-color: transparent;
    //   }
    //   &:visited {
    //     background-color: transparent;
    //   }
    // }

    ::v-deep .is-current {
      >.el-tree-node__content {
        background: transparent;
        border-radius: 8px;
      }
    }

    .custom-tree-node {
      flex: 1;
      min-width: 0;
      // margin-left: -10px;
    }

    .tree-label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .label-container {
        min-width: 0;
        display: flex;
        align-items: center;
        width: 100%;

        // display: block;
        span {
          width: 100%;
          display: inline-block;
          box-sizing: border-box;
          padding-right: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #3e4a70;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        img {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }

        .select-yuan {
          display: flex;
          align-items: center;
          justify-content: center;
          width: .2rem;
          height: .2rem;
          background: #FFFFFF;
          border-radius: 50%;
          border: 1px solid #2DAEA9;
          box-sizing: border-box;
        }

        .select-yuan-act {
          &::before {
            content: "";
            width: .1rem;
            height: .1rem;
            background: #2DAEA9;
            border-radius: 50%;
          }
        }

        .area-name {
          width: 80%;
          text-align: left;
          padding-left: .125rem;
        }
      }

      ::v-deep .el-input {
        height: 36px;
        margin-right: 25px;

        .el-input__inner {
          height: 100% !important;
        }
      }

      .handle {
        min-width: 0;
        flex-shrink: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        img {
          width: 16px;
          margin-right: 5px;
        }

        .add {
          width: 20px;
        }

        &.save {
          img {
            width: 16px;
            margin-right: 7px;
          }
        }
      }
    }
  }
}
</style>
<style>
.tree-active-node {
  border-radius: 8px !important;
  /* background-color: #edf3fe !important; */
}
</style>
